import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function AuthCallback() {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // Récupérer les paramètres de l'URL (ex: ?token=xyz&role=customer)
        const params = new URLSearchParams(location.search);
        const token = params.get('token');
        const userStr = params.get('user'); // Si ton backend renvoie l'objet utilisateur sérialisé

        if (token) {
            // Stocker le token dans le localStorage
            localStorage.setItem('token_customer_silverjarz', token);
            
            if (userStr) {
                try {
                    const user = JSON.parse(userStr);
                    localStorage.setItem('customer_silverjarz', JSON.stringify(user));
                    
                    // Redirection selon le rôle ou vers le dashboard directement
                    if (user.role === 'admin') {
                        navigate('/admin-dashboard');
                    } else {
                        navigate('/my-dashboard');
                    }
                } catch (e) {
                    navigate('/dashboard');
                }
            } else {
                // Redirection par défaut vers le dashboard
                navigate('/dashboard');
            }
        } else {
            // Si le token est absent, renvoyer vers la page de login avec une erreur
            navigate('/login?error=google_auth_failed');
        }
    }, [location, navigate]);

    return (
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h3>Connexion en cours, veuillez patienter...</h3>
        </div>
    );
}

export default AuthCallback;